import { EventEmitter, Injectable } from "@angular/core";
import { SortTypeEnum } from "src/domain/client";

export interface IReloadSearchParameters {
  emit: boolean;
  query: string;
}

@Injectable({
  providedIn: "root",
})
export class ProductListService {
  reloadSearch$ = new EventEmitter<IReloadSearchParameters>();

  sortType: SortTypeEnum = SortTypeEnum.AlphabeticalAscending;

  reloadSearch(reloadSearchParameters: IReloadSearchParameters): void {
    this.reloadSearch$.emit(reloadSearchParameters);
  }

  setSortType(sortType: SortTypeEnum, query: string = ""): void {
    this.sortType = sortType;

    const params: IReloadSearchParameters = {
      emit: false,
      query,
    };

    this.reloadSearch(params);
  }
}
